/* eslint-disable react/prop-types */
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import Switch from 'react-switch'
import { Col, Row, FormGroup, Input, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState, packageTypeOptions } from './constants'
import RFIInfantMeatsProduct from 'models/RFIInfantMeatsProduct'

const RFIInfantMeatsPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const methods = useFormContext()

  const { setSelect, setSwitch, onChange, asterisk } = useFormUtils()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (current?.category === packagingInitialState.category) {
      const {
        category,
        subCategory,
        PackageType,
        Size,
        MultiPackageType,
        MultiPackageCount,
        Organic,
        NoAdditionalIngredients,
      } = current

      setPackaging({
        category,
        subCategory,
        PackageType: {
          value: PackageType || '',
          label: PackageType.length > 0 ? PackageType : 'Package Type',
        },
        Size,
        MultiPackageType,
        MultiPackageCount,
        Organic,
        NoAdditionalIngredients,
      })
    } else if (!updating) {
      setCurrent(RFIInfantMeatsProduct)
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.MultiPackageType) {
        methods.setValue('MultiPackageCount', current.MultiPackageCount)
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating])

  return (
    <Row>
      <Col xs={4}>
        <p>
          <strong>Package Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={packageTypeOptions}
          name="PackageType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Package Type'}
          onChange={([selected]) => {
            setSelect(selected, 'PackageType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PackageType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
        </FormGroup>
        <Input value={packaging.Size} disabled />
      </Col>
      <Col xs={4}>
        <p>
          <strong>Multi-pack</strong>
        </p>
        <Controller
          as={Switch}
          name="MultiPackageType"
          id="MultiPackageType"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.MultiPackageType}
        />
        <br />
        <br />
        <br />
        {current?.MultiPackageType === true && (
          <FormGroup>
            <p>
              <strong>Multi-pack Count {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="MultiPackageCount"
              placeholder={'Multi-pack Count'}
              onKeyDown={e => {
                if (
                  ![
                    'Backspace',
                    'Delete',
                    'Tab',
                    'ArrowLeft',
                    'ArrowRight',
                  ].includes(e.key) &&
                  isNaN(parseInt(e.key))
                ) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: { value: 2, message: '⚠ 2 characters max.' },
                required: {
                  value: true,
                  message: '⚠ Multi Pack Count is required.',
                },
                min: {
                  value: 1,
                  message: '⚠ Multi Pack Count must be at least 1.',
                },
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="MultiPackageCount"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
      </Col>
      <Col xs={4}>
        <p>
          <strong>Organic</strong>
        </p>
        <Controller
          as={Switch}
          name="Organic"
          id="Organic"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id, '101RFI', '001RFI')
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.Organic}
        />
        <br />
        <hr />
        <p>
          <strong>
            I certify that this product does not contain added sugars, salt,
            spices, fiber, or DHA. {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="NoAdditionalIngredients"
          id="NoAdditionalIngredients"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.NoAdditionalIngredients}
          rules={{
            validate: NoAdditionalIngredients =>
              NoAdditionalIngredients === true,
          }}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="NoAdditionalIngredients"
            message={
              '⚠ You must certify that this product does not contain added sugars, salt, spices, fiber, or DHA.'
            }
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

export default RFIInfantMeatsPackage
